import React from 'react'
import { Link } from 'react-router-dom';

function Abscence() {
  return (
    <div className='messageriebox'>     
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Liste des avis d'absence</p>
        <hr/> 
       
      
    </div>
  )
}

export default Abscence